import React from "react";
import styled from "styled-components";
import successSrc from "../../img/success.svg";
import { Text } from "../../components/Text";
import { Flex } from "../../components/Flex";
import Button from "../../components/Button";
import { FaArrowCircleRight } from "react-icons/fa";

const Image = styled.img`
  margin: 36px;
  max-width: 100%;
  width: 800px;
`;

Image.defaultProps = {
  src: successSrc
};

const Success = () => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      p={3}
      pt={5}
    >
      <Image />
      <Text fontSize={7} fontWeight={600}>
        Success!
      </Text>
      <Text fontSize={5} fontWeight={600} mb={4}>
        Thank you for joining the timeboxing revolution!
      </Text>
      <Button large to="/schedule" icon={FaArrowCircleRight}>
        Let's get started!
      </Button>
    </Flex>
  );
};

export default Success;
